export default __webpack_public_path__ + "2010f3dce3f1024394ef6760d3bcddd9.svg";